export const UpdateFilterData = (data) => {
  return {
    type: 'FILTER_DATA',
    payload: data
  };
};
